import React from 'react'
import { useForm } from 'react-hook-form'
import CrudEdit from '~/components/CrudEdit'
import IWeaponKind from '../interfaces/IWeaponKind'
import Layout from '~/components/Layout'

export default function Edit() {
  const {
    register,
    handleSubmit,
    control,
    setValue: setFormValue,
    getValues,
  } = useForm<IWeaponKind>()

  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string' },
    {
      name: 'reapon_type_id',
      type: 'selectAutoComplete',
      model: 'weapon-type',
      placeholder: 'Weapon Type',
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudEdit
        model={'weapon-kind'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        setFormValue={setFormValue}
        messageSuccess={'Weapon kind successfully updated!'}
        title={'Edit weapon kind'}
        getValues={getValues}
      />
    </Layout>
  )
}
